module.exports = __webpack_public_path__ + "img/mana3.2a8f000d.png";